import React, {
  Dispatch,
  FunctionComponent,
  ReactNode,
  SetStateAction,
  createContext,
  useState
} from 'react';

interface ContentViewContextState {
  assetKey: string | null;
  setAssetKey: Dispatch<SetStateAction<string>>;
}

export const ContentViewContext = createContext<ContentViewContextState>({
  assetKey: null,
  setAssetKey: () => { /* no op */ }
});

interface ContentViewContextProps {
  children: ReactNode;
}

export const ContentViewProvider: FunctionComponent<ContentViewContextProps> = ({ children }) => {
  const [assetKey, setAssetKey] = useState<string>(null);
  return (
    <ContentViewContext.Provider value={{ assetKey, setAssetKey }}>{children}</ContentViewContext.Provider>
  );
};
